import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { CircleAlert, Database, MousePointerClick } from "lucide-react";

const navItems = [
  ["KHORN Web App", "/product"],
  ["KHORN LINE", "/line"],
  ["KHORN MCP", "/mcp"],
  ["ราคา", "#pricing"],
  ["ความปลอดภัย", "/privacy"],
  ["ติดต่อ", "/contact"],
];

const lineUseCases = [
  {
    label: "ตอบกฎหมาย",
    user: "ทำร้ายร่างกายผิดยังไง",
    ai: "พี่คะ หนูเช็คฐานกฎหมายให้แล้ว เรื่องนี้ต้องดูตามผลของการบาดเจ็บ ตั้งแต่บาดเจ็บธรรมดา อันตรายสาหัส ไปจนถึงเป็นเหตุให้ถึงแก่ความตาย",
    refs: ["ป.อ. มาตรา 295", "ป.อ. มาตรา 297", "ฎีกาที่เกี่ยวข้อง"],
    cardTitle: "คำตอบพร้อมอ้างอิง",
    cardSubtitle: "กดตรวจตัวบทและฎีกาได้",
    cardLines: [
      "มาตราและแนวคำพิพากษาถูกแนบมากับคำตอบ",
      "ใช้เป็นฐานให้ทีมตรวจและร่างเอกสารต่อ",
    ],
    button: "เปิดแหล่งอ้างอิง",
  },
  {
    label: "มอบหมายงาน",
    user: "มอบหมายให้เมย์สรุปหลักฐานคดีคุณวิทยา ภายในวันนี้",
    ai: "หนูเพิ่มงานให้แล้วนะคะ อยู่ในแฟ้มคดีคุณวิทยา กำหนดส่งวันนี้ 17:00",
    refs: [],
    cardTitle: "เพิ่มงานใหม่",
    cardSubtitle: "บันทึกเข้า KHORN แล้ว",
    cardLines: [
      "ผู้รับผิดชอบ: เมย์",
      "กำหนดส่ง: วันนี้ 17:00",
      "ผูกกับแฟ้มคดีคุณวิทยา",
    ],
    button: "เปิดงาน",
  },
  {
    label: "งานที่ยังไม่เสร็จ",
    user: "มีอะไรยังไม่เสร็จบ้าง",
    ai: "หนูเช็คให้แล้วค่ะ ตอนนี้มีงานที่ยังไม่กดเสร็จ 3 รายการ เดี๋ยวหนูสรุปให้ดูเลย",
    refs: [],
    cardTitle: "งานที่ยังไม่เสร็จ",
    cardSubtitle: "พบ 3 รายการล่าสุด",
    cardLines: [
      "รอเอกสารค่าเสียหาย",
      "ตรวจร่างหนังสือทวงถาม",
      "ยืนยันวันนัดลูกความ",
    ],
    button: "เปิด KHORN",
  },
  {
    label: "งานใหม่",
    user: "งานใหม่ของฉันมีอะไรบ้าง",
    ai: "มีงานใหม่เข้ามาค่ะ หนูแปะไว้ในแฟ้มคดีผิดสัญญาจ้างบริการให้แล้ว",
    refs: [],
    cardTitle: "งานใหม่",
    cardSubtitle: "ตรวจร่างสัญญาจ้างบริการ",
    cardLines: [
      "กำหนดส่ง: พรุ่งนี้ 12:00",
      "เจ้าของเคส: ทีมสัญญา",
    ],
    button: "เปิดงาน",
  },
  {
    label: "รายงานสรุป",
    user: "ส่งรายงานสรุปงานประจำวัน",
    ai: "หนูสรุปรายงานวันนี้ให้แล้วค่ะ งานเสร็จไปเยอะ แต่ยังมีบางจุดที่ควรตามต่อ",
    refs: [],
    cardTitle: "รายงานสรุปวันนี้",
    cardSubtitle: "8 งานเสร็จแล้ว",
    cardLines: [
      "ค้าง 4 งาน",
      "2 เคสต้องตามเอกสารเพิ่ม",
      "1 กำหนดเวลาจะถึงพรุ่งนี้",
    ],
    button: "ดูรายงาน",
  },
  {
    label: "ตามงาน",
    user: "ตามงานเอกสารลูกความคดีบริษัท A",
    ai: "หนูตามเอกสารให้แล้วนะคะ ถ้าลูกความยังไม่ตอบใน 24 ชั่วโมง หนูจะเตือนซ้ำให้อีกที",
    refs: [],
    cardTitle: "ตามงานลูกความ",
    cardSubtitle: "ตั้งเตือนซ้ำใน 24 ชั่วโมง",
    cardLines: [
      "ขอสำเนาสัญญา",
      "ขอหลักฐานการโอนเงิน",
      "ขอลำดับเหตุการณ์",
    ],
    button: "ดูสถานะ",
  },
];

const pricing = [
  {
    name: "Plus",
    price: "299",
    desc: "สำหรับนักกฎหมาย 1 คนที่ต้องการฐานข้อมูลกฎหมาย AI ร่างเอกสาร และเครื่องมือจัดการงานในที่เดียว",
    href: "https://app.khorn-ai.com/signup?plan=elite&commitment=monthly",
    features: [
      "ฐานข้อมูลกฎหมาย",
      "ร่างเอกสาร",
      "KHORN MCP",
      "KHORN LINE",
      "จัดการสำนักงาน 1 ที่นั่ง",
    ],
    featured: true,
  },
  {
    name: "Pro",
    price: "799",
    desc: "สำหรับทีมกฎหมายขนาดเล็กที่ต้องทำงานร่วมกัน มอบหมายงาน และเห็นภาพรวมของทีม",
    href: "https://app.khorn-ai.com/signup?plan=team&commitment=monthly",
    features: [
      "ทุกอย่างใน Plus",
      "เชิญทีมได้ 4 ที่นั่ง",
      "จัดการทีม",
      "มอบหมายงานและติดตามงานทีม",
    ],
  },
  {
    name: "Custom",
    price: "ปรับได้",
    desc: "สำหรับสำนักงานที่ต้องการระบบเฉพาะ การเชื่อมต่อ และการควบคุมระดับองค์กร",
    href: "https://app.khorn-ai.com/plan",
    features: [
      "ตั้งค่าขั้นตอนงานเฉพาะ",
      "เชื่อมต่อระบบภายใน",
      "สิทธิ์ผู้ใช้และประวัติการทำงาน",
      "ช่วยเริ่มต้นใช้งานทีม",
    ],
  },
];

const testimonials = [
  "เห็นทันทีว่าเคสไหนค้างเพราะขาดเอกสาร ไม่ต้องถามกันหลายรอบ",
  "ข้อมูลจาก LINE ลูกความถูกสรุปเป็นข้อเท็จจริงและงานที่ต้องทำต่อได้เร็วมาก",
  "ทีมผู้ช่วยทนายรู้ว่าต้องเตรียมอะไร ก่อนส่งให้หัวหน้าทีมตรวจ",
  "การร่างหนังสือทวงถามเร็วขึ้น เพราะ AI จัดลำดับเหตุการณ์และหลักฐานให้ก่อน",
  "ระบบทำให้การติดตามงานลูกความเป็นระบบขึ้น ไม่ใช่จำกันในแชต",
  "เหมาะกับสำนักงานที่มีหลายเคสและต้องการเห็นภาพรวมทุกวัน",
  "เปิดมาตอนเช้าก็เห็นเลยว่าวันนี้ต้องตามอะไร ไม่ต้องไล่ถามในกลุ่ม",
  "ช่วยแยกข้อมูลลูกความออกจากบทสนทนายาว ๆ ได้ไวขึ้นมาก",
  "เวลาประชุมทีมสั้นลง เพราะทุกคนเห็นสถานะงานจากที่เดียวกัน",
  "ร่างเอกสารรอบแรกเร็วขึ้น แล้วทีมมีเวลาตรวจเนื้อหาจริงมากขึ้น",
  "ค้นตัวบทและฎีกาต่อได้ง่ายกว่าเดิม เพราะมีแหล่งอ้างอิงให้เปิดดู",
  "งานตามเอกสารไม่หลุด เพราะระบบช่วยบอกว่ายังขาดอะไร",
  "ทีมใหม่เข้ามาก็เข้าใจเคสเร็วขึ้นจากสรุปและงานที่ต้องทำต่อ",
  "ใช้ LINE ถามงานเล็ก ๆ ได้เลย ไม่ต้องเปิดระบบใหญ่ทุกครั้ง",
  "ลดเวลาจัดไฟล์ก่อนเริ่มร่างได้เยอะ โดยเฉพาะเคสที่เอกสารกระจาย",
  "เห็นภาพรวมงานค้างของทั้งทีมแบบไม่ต้องทำรายงานแยก",
];

const faqs = [
  {
    q: "KHORN AI คืออะไร?",
    a: "KHORN AI คือชุดผลิตภัณฑ์สำหรับงานกฎหมาย มีทั้ง KHORN Web App สำหรับจัดการงานคดี, KHORN LINE สำหรับถามและร่างผ่าน LINE, และ KHORN MCP สำหรับต่อฐานกฎหมายเข้ากับเครื่องมือ AI ที่ทีมใช้อยู่",
  },
  {
    q: "KHORN MCP มี AI ตอบคำถามไหม?",
    a: "ไม่มี KHORN MCP วางตัวเป็นเครื่องมือค้นแหล่งข้อมูลโดยตรง เช่น กฎหมายและฎีกา เพื่อให้ผู้ใช้เปิดตรวจต้นทางเอง",
  },
  {
    q: "ควรเริ่มจากผลิตภัณฑ์ไหน?",
    a: "ถ้าต้องการจัดการทีมและงานคดีให้เริ่มจาก KHORN Web App ถ้าต้องการผู้ช่วยใน LINE ให้ใช้ KHORN LINE และถ้าต้องการต่อฐานกฎหมายเข้ากับเครื่องมือ AI ให้ใช้ KHORN MCP",
  },
];

const seoJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.khorn-ai.com/#organization",
      name: "KHORN AI",
      url: "https://www.khorn-ai.com/",
      sameAs: ["https://www.facebook.com/khornaisolution"],
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://www.khorn-ai.com/#software",
      name: "KHORN AI",
      applicationCategory: "LegalTechApplication",
      operatingSystem: "Web",
      url: "https://www.khorn-ai.com/",
      description:
        "ชุดผลิตภัณฑ์ LegalTech สำหรับทีมกฎหมายไทย ครอบคลุม KHORN Web App สำหรับจัดการงานคดี, KHORN LINE สำหรับถามและร่างผ่าน LINE, และ KHORN MCP สำหรับต่อฐานกฎหมายเข้ากับ AI workspace",
      offers: {
        "@type": "Offer",
        priceCurrency: "THB",
        price: "399",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    },
  ],
};

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-white text-[#15130F]">
      <Helmet>
        <title>KHORN AI | AI สำหรับงานกฎหมายไทย</title>
        <meta
          name="description"
          content="KHORN AI คือ AI สำหรับงานกฎหมายไทย ครอบคลุมการค้นกฎหมายและฎีกา ร่างเอกสาร จัดการงานคดี และต่อฐานกฎหมายเข้ากับ AI workspace"
        />
        <meta
          name="keywords"
          content="AI สำหรับงานกฎหมายไทย, AI สำหรับงานกฎหมาย, AI for legal tasks, legal task AI, KHORN Web App, KHORN LINE, KHORN MCP, ค้นฎีกา, ค้นกฎหมาย, ระบบจัดการเคส, AI ช่วยงานทนาย"
        />
        <meta property="og:title" content="KHORN AI | AI สำหรับงานกฎหมายไทย" />
        <meta
          property="og:description"
          content="AI สำหรับงานกฎหมายไทย: ค้นกฎหมายและฎีกา ร่างเอกสาร จัดการงานคดี และต่อฐานกฎหมายเข้ากับ AI workspace"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.khorn-ai.com/" />
        <meta property="og:image" content="https://www.khorn-ai.com/logo.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.khorn-ai.com/" />
        <script type="application/ld+json">{JSON.stringify(seoJsonLd)}</script>
      </Helmet>
      <Header />

      <Hero />
      <AgentsSection />
      <ProductFamilySection />
      <SetupSection />
      <PlatformSection />
      <McpSection />
      <SecuritySection />
      <PricingSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
    </main>
  );
}

function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-[#E8EAE5] bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1440px] items-center justify-between px-4 py-4 md:px-6">
        <a href="/" className="flex items-center gap-3" aria-label="KHORN AI home">
          <span className="relative block h-11 w-[172px] shrink-0 overflow-hidden">
            <img
              src="/logo_and_name.png"
              alt="KHORN AI"
              className="absolute -left-[28px] -top-[60px] h-[168px] max-w-none"
            />
          </span>
        </a>

        <nav className="hidden items-center gap-8 text-[13px] text-[#5F665E] md:flex">
          {navItems.map(([label, href]) => (
            <a key={label} href={href} className="hover:text-[#15130F]">
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://app.khorn-ai.com"
            className="hidden text-[13px] font-medium text-[#5F665E] hover:text-[#15130F] sm:block"
          >
            สมัคร
          </a>
          <a
            href="https://app.khorn-ai.com/plan"
            className="rounded-full bg-[#15130F] px-5 py-2.5 text-[13px] font-medium text-[#FAFAF7] transition hover:bg-[#1F2A22]"
          >
            เริ่มใช้งาน
          </a>
        </div>
      </div>
    </header>
  );
}

function Hero() {
  return (
    <section className="relative min-h-[820px] overflow-hidden bg-white px-5 pb-10 pt-24 text-center md:px-10 md:pt-32">
      <HeroDoodles />

      <div className="relative z-10 mx-auto w-full max-w-6xl">
        <div className="relative mx-auto max-w-5xl">
          <h1 className="relative z-10 text-[48px] font-semibold leading-[0.95] tracking-[-0.06em] text-[#15130F] md:text-[76px] lg:text-[92px]">
            จัดการงานคดี
            <br />
            จาก 3 ชั่วโมงใน 3 นาที
          </h1>
          <AnimatedMascot className="absolute right-[2%] top-[-14px] z-20 hidden h-24 w-32 md:block lg:right-[3%] lg:top-[-22px] lg:h-32 lg:w-44" />
        </div>

        <p className="mx-auto mt-9 max-w-3xl text-lg leading-8 tracking-[-0.02em] text-[#5F665E] md:text-xl md:leading-8">
          ค้นกฎหมายและฎีกา และจัดการเอกสารสำนักงานกฎหมาย
        </p>

        <div className="mt-8 flex items-center justify-center">
          <a
            href="https://app.khorn-ai.com/plan"
            className="rounded-lg bg-[#15130F] px-9 py-4 text-center text-base font-semibold text-[#FAFAF7] shadow-[0_8px_18px_rgba(0,0,0,0.16)] transition hover:bg-[#1F2A22]"
          >
            ใช้งานเลย!
          </a>
        </div>

        <div className="mx-auto mt-24 grid max-w-6xl gap-8 md:grid-cols-3">
          {[
            ["10,000+", "คดีที่ช่วยจัดระเบียบ"],
            ["891,978+", "นาทีที่ช่วยประหยัดเวลา"],
            ["2,000+", "ทนายที่ใช้งาน"],
          ].map(([value, label], index) => (
            <div
              key={label}
              className={`px-4 ${index > 0 ? "md:border-l md:border-[#E8EAE5]" : ""}`}
            >
              <div
                className={`text-5xl font-semibold tracking-[-0.06em] md:text-6xl ${
                  index === 0
                    ? "text-[#3777E3]"
                    : index === 1
                      ? "text-[#F5A11A]"
                      : "text-[#18A64A]"
                }`}
              >
                {value}
              </div>
              <div className="mt-3 text-sm font-semibold text-[#7C8579]">
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductFamilySection() {
  const placements = [
    {
      title: "KHORN Web App",
      desc: "เว็บไซต์สำหรับจัดการเคส ลูกความ ทีม เอกสาร และภาพรวมงาน",
      href: "/product",
      logos: [
        { type: "browser", alt: "Browser" },
        { type: "image", src: "/logo.png", alt: "KHORN AI" },
      ],
    },
    {
      title: "KHORN LINE",
      desc: "ผู้ช่วยใน LINE สำหรับถาม ร่าง เช็กงาน และรับแจ้งเตือน",
      href: "/line",
      logos: [
        { type: "line", alt: "LINE" },
        { type: "image", src: "/logo.png", alt: "KHORN AI" },
      ],
    },
    {
      title: "KHORN MCP",
      desc: "ต่อฐานกฎหมายไทยเข้ากับ Codex, Claude และเครื่องมือ AI",
      href: "/mcp",
      logos: [
        { type: "image", src: "/images/codex-logo.png", alt: "Codex" },
        { type: "image", src: "/images/claude-logo.svg", alt: "Claude" },
      ],
    },
  ];

  return (
    <section id="product" className="relative bg-white px-4 py-20 md:px-6 md:py-24">
      <div className="mx-auto max-w-[1440px]">
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#6A7168]">
            KHORN ใช้ได้ที่ไหน
          </p>
          <h2 className="mt-5 text-4xl font-semibold leading-tight tracking-[-0.05em] text-[#242622] md:text-6xl">
            KHORN อยู่ในเครื่องมือที่ทีมใช้อยู่แล้ว
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-lg leading-8 text-[#6A7168]">
            KHORN Web App, KHORN LINE และ KHORN MCP
          </p>
        </div>

        <div className="mt-14 grid gap-5 lg:grid-cols-3">
          {placements.map((placement) => (
            <a
              key={placement.title}
              href={placement.href}
              className="group flex min-h-[330px] flex-col rounded-[32px] bg-[#FAFAF7] p-7 text-center transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_70px_rgba(22,29,24,0.08)]"
            >
              <div className="mx-auto flex items-center justify-center gap-4">
                {placement.logos.map((logo, index) => (
                  <ProductLogo key={`${placement.title}-${index}`} logo={logo} />
                ))}
              </div>

              <h3 className="mt-10 text-4xl font-semibold leading-[1.02] tracking-[-0.06em] text-[#15130F]">
                {placement.title}
              </h3>
              <p className="mx-auto mt-5 max-w-xs text-base leading-7 text-[#5F665E]">
                {placement.desc}
              </p>

              <span className="mt-auto pt-8 text-sm font-semibold text-[#15130F]">
                ดูรายละเอียด <span className="inline-block transition group-hover:translate-x-1">→</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductLogo({ logo, small = false }) {
  const shellClass = small
    ? "grid h-8 w-8 place-items-center rounded-xl bg-white shadow-sm"
    : "grid h-20 w-20 place-items-center rounded-[24px] bg-white shadow-[0_14px_36px_rgba(22,29,24,0.08)]";
  const lineClass = small
    ? "grid h-5 w-5 place-items-center rounded-md bg-[#06C755] text-[5px] font-black text-white"
    : "grid h-12 w-12 place-items-center rounded-[14px] bg-[#06C755] text-sm font-black text-white";
  const imageClass = small ? "h-6 w-6 object-contain" : "h-12 w-12 object-contain";
  const browserImageClass = small ? "h-5 w-5 object-contain" : "h-12 w-12 object-contain";

  if (logo.type === "line") {
    return (
      <span className={shellClass}>
        <span className={lineClass}>
          LINE
        </span>
      </span>
    );
  }

  if (logo.type === "browser") {
    return (
      <span className={shellClass}>
        <img src="/images/google-chrome-logo.svg" alt={logo.alt} className={browserImageClass} />
      </span>
    );
  }

  return (
    <span className={shellClass}>
      <img src={logo.src} alt={logo.alt} className={imageClass} />
    </span>
  );
}

function McpSection() {
  return (
    <section id="mcp-product" className="bg-white px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto grid max-w-[1180px] items-center gap-12 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <div className="mb-5 inline-flex items-center gap-3 rounded-full bg-[#F4F6FF] px-4 py-2">
            <span className="grid h-8 w-8 place-items-center rounded-xl bg-white shadow-sm">
              <img src="/images/codex-logo.png" alt="" aria-hidden="true" className="h-6 w-6 object-contain" />
            </span>
            <span className="grid h-8 w-8 place-items-center rounded-xl bg-white shadow-sm">
              <img src="/images/claude-logo.svg" alt="" aria-hidden="true" className="h-6 w-6 object-contain" />
            </span>
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#3777E3]">
              KHORN MCP
            </span>
          </div>
          <h2 className="max-w-3xl text-5xl font-semibold leading-[0.98] tracking-[-0.06em] md:text-7xl">
            ต่อฐานกฎหมายกับ AI ของคุณ
          </h2>
          <p className="mt-6 text-2xl font-semibold tracking-[-0.04em] text-[#5F665E]">
            KHORN MCP
          </p>
          <a
            href="/mcp"
            className="mt-8 inline-flex h-12 items-center justify-center rounded-full bg-[#15130F] px-6 text-sm font-medium text-white transition hover:bg-[#1F2A22]"
          >
            ดูฐานข้อมูล
          </a>
        </div>

        <div className="relative min-h-[420px]">
          <div className="absolute left-1/2 top-[106px] h-[150px] w-px -translate-x-1/2 bg-[#DDE3D8]" />
          <div className="absolute left-[24%] top-[106px] h-px w-[52%] bg-[#DDE3D8]" />

          <div className="relative grid grid-cols-2 gap-10 pt-10">
            <McpToolLogo logo="/images/codex-logo.png" />
            <McpToolLogo logo="/images/claude-logo.svg" />
          </div>

          <McpToolLogo logo="/logo.png" className="relative mx-auto mt-24" />
        </div>
      </div>
    </section>
  );
}

function McpToolLogo({ logo, className = "" }) {
  return (
    <div className={`grid min-h-[132px] place-items-center ${className}`}>
      <div className="grid h-32 w-32 place-items-center rounded-[34px] bg-white shadow-[0_24px_70px_rgba(22,29,24,0.12)]">
        <img
          src={logo}
          alt=""
          aria-hidden="true"
          className="h-20 w-20 object-contain"
        />
      </div>
    </div>
  );
}

function HeroDoodles() {
  return null;
}

function AnimatedMascot({ className = "", mood = "working" }) {
  return (
    <span className={`${className} block`}>
      <img
        src={`/animation/${mood}_1.png`}
        alt=""
        aria-hidden="true"
        className="mascot-frame-a absolute inset-0 h-full w-full object-contain"
      />
      <img
        src={`/animation/${mood}_2.png`}
        alt=""
        aria-hidden="true"
        className="mascot-frame-b absolute inset-0 h-full w-full object-contain"
      />
    </span>
  );
}

function LogoAvatar({ className = "" }) {
  return (
    <span className={`grid h-10 w-10 shrink-0 place-items-center overflow-hidden rounded-full bg-white ${className}`}>
      <img src="/logo.png" alt="KHORN AI" className="h-7 w-7 object-contain" />
    </span>
  );
}

function AgentsSection() {
  const painCards = [
    {
      color: "#78C46B",
      icon: "case",
      title: "ทำงานไม่ทันเพราะหาข้อมูลคดีไม่เจอ",
      desc: "ข้อมูลอยู่หลายช่องทาง หลายไฟล์ หลายบทสนทนา ทำให้ทีมเสียเวลาไล่หาก่อนเริ่มงานจริง",
    },
    {
      color: "#5F83E8",
      icon: "search",
      title: "เครื่องมือที่ใช้งานไม่สะดวกสบาย",
      desc: "งานเล็ก ๆ ต้องเปิดหลายระบบ หลายหน้า หลายขั้นตอน จนทีมไม่อยากใช้งานจริง",
    },
    {
      color: "#FF9828",
      icon: "folder",
      title: "AI ตัวที่ใช้ตอบกฎหมายมั่ว",
      desc: "คำตอบดูน่าเชื่อ แต่ไม่มีแหล่งอ้างอิงที่ตรวจต่อได้ ทำให้เสี่ยงกับงานกฎหมายจริง",
    },
  ];

  return (
    <section className="relative bg-white px-4 py-24 md:px-6 md:py-28">
      <div className="mx-auto max-w-[1440px]">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-semibold leading-tight tracking-[-0.05em] text-[#242622] md:text-5xl">
            ปัญหาที่ทำให้ทีมกฎหมายเสียเวลา
          </h2>
          <p className="mt-5 text-lg leading-8 text-[#6A7168]">
            ไม่ใช่แค่งานเยอะ แต่เป็นข้อมูลกระจัดกระจาย เครื่องมือใช้ยาก และคำตอบที่ตรวจต่อไม่ได้
          </p>
        </div>

        <div className="mt-14 grid gap-8 lg:grid-cols-3">
          {painCards.map((item) => (
            <article
              key={item.title}
              className="min-h-[270px] rounded-[28px] bg-white px-8 py-10 text-center shadow-[0_24px_70px_rgba(22,29,24,0.08)]"
            >
              <ProblemIcon type={item.icon} color={item.color} />
              <h3 className="mt-7 text-2xl font-semibold tracking-[-0.04em] text-[#242622] md:text-3xl">
                {item.title}
              </h3>
              <p className="mx-auto mt-5 max-w-md text-base leading-8 text-[#6A7168]">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function ProblemIcon({ type, color }) {
  const Icon = type === "case"
    ? Database
    : type === "search"
      ? MousePointerClick
      : CircleAlert;

  return (
    <div className="mx-auto grid h-20 w-20 place-items-center rounded-[24px] bg-[#F5F7F1]" style={{ color }}>
      <Icon size={36} strokeWidth={1.9} />
    </div>
  );
}

function SetupSection() {
  const items = [
    "รับข้อมูลจาก LINE, email, files และทีมในที่เดียว",
    "สรุปข้อเท็จจริง เอกสารที่มี และสิ่งที่ยังขาด",
    "ค้นกฎหมายและข้อมูลประกอบที่เกี่ยวข้องกับคดี",
    "เตรียมร่างเอกสารและงานที่ต้องทำต่อให้ทีมตรวจ",
    "ติดตามงานค้าง กำหนดเวลา และคนรับผิดชอบให้คดีไม่หยุด",
  ];

  return (
    <section id="web-product" className="relative overflow-hidden bg-white px-4 py-20 md:px-6 md:py-28">
      <div className="mx-auto grid max-w-[1280px] items-center gap-16 lg:grid-cols-[1.1fr_0.9fr]">
        <article className="relative mx-auto w-full max-w-3xl">
          <div className="rounded-[22px] border border-[#D9DDD6] bg-[#E8EAE5] p-px shadow-[0_24px_70px_rgba(22,29,24,0.08)]">
            <div className="overflow-hidden rounded-[19px] bg-white">
              <div className="flex h-9 items-center gap-2 border-b border-[#ECEFEB] bg-[#FAFAF7] px-4">
                <span className="h-3 w-3 rounded-full bg-[#FF5F57]" />
                <span className="h-3 w-3 rounded-full bg-[#FFBD2E]" />
                <span className="h-3 w-3 rounded-full bg-[#28C840]" />
                <div className="mx-auto hidden h-6 w-64 items-center justify-center rounded-full bg-white text-[10px] font-semibold text-[#8A9288] md:flex">
                  app.khorn-ai.com
                </div>
              </div>

              <div className="grid min-h-[390px] grid-cols-[156px_1fr] text-[#15130F] sm:grid-cols-[190px_1fr]">
                <aside className="border-r border-[#ECEFEB] bg-[#FAFAF7] p-4">
                  <div className="mb-7 flex items-center gap-2">
                    <img src="/logo.png" alt="" aria-hidden="true" className="h-5 w-5 object-contain" />
                    <span className="text-xs font-semibold">KHORN AI</span>
                  </div>
                  <div className="space-y-3 text-[11px] font-semibold text-[#7C8579]">
                    {["เริ่มงานใหม่", "สำนักงาน", "แฟ้มคดีทั้งหมด"].map((item) => (
                      <div key={item} className="rounded-xl bg-white px-3 py-2">
                        {item}
                      </div>
                    ))}
                  </div>
                  <p className="mt-7 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#A3AAA0]">
                    แฟ้มคดี
                  </p>
                  <div className="mt-3 space-y-2 text-[10px] font-semibold text-[#5F665E]">
                    {[
                      "คดีรุกล้ำที่ดินคุณสมชาย",
                      "คดีซื้อโฆษณา",
                      "ข้อพิพาทสัญญา ABC",
                      "คดีแรงงานเลิกจ้าง",
                    ].map((item) => (
                      <div key={item} className="truncate rounded-lg px-2 py-2">
                        ▱ {item}
                      </div>
                    ))}
                  </div>
                </aside>

                <main className="relative flex flex-col items-center justify-center p-6">
                  <div className="mb-7 flex items-center gap-3">
                    <img src="/logo.png" alt="" aria-hidden="true" className="h-7 w-7 object-contain" />
                    <h3 className="text-xl font-semibold tracking-[-0.04em] md:text-2xl">
                      ให้ค้อนเอไอช่วยงานคดียังไงดีครับ
                    </h3>
                  </div>

                  <div className="w-full max-w-md rounded-[24px] bg-white p-3 shadow-[0_18px_60px_rgba(22,29,24,0.10)]">
                    <div className="min-h-[74px] rounded-[18px] border border-[#ECEFEB] px-4 py-3 text-sm text-[#A3AAA0]">
                      ถามคำถาม...
                    </div>
                    <div className="mt-3 flex items-center justify-between px-2 text-[#8A9288]">
                      <span className="text-xl">＋</span>
                      <span className="grid h-9 w-9 place-items-center rounded-full bg-[#D8DBD6] text-white">↑</span>
                    </div>
                  </div>

                  <div className="mt-6 flex flex-wrap justify-center gap-2">
                    {["มาตรา", "ฎีกา", "ร่างเอกสาร", "ขั้นตอนงาน"].map((item) => (
                      <span key={item} className="rounded-full border border-[#DDE3D8] px-4 py-2 text-xs font-semibold text-[#6A7168]">
                        {item}
                      </span>
                    ))}
                  </div>

                  <AnimatedMascot className="absolute bottom-5 right-6 h-20 w-24 opacity-90" mood="working" />
                </main>
              </div>
            </div>
          </div>
        </article>

        <article>
          <div className="mb-5 inline-flex items-center gap-3 rounded-full bg-[#F6F8F4] px-4 py-2">
            <ProductLogo logo={{ type: "browser", alt: "Browser" }} small />
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#5F665E]">
              KHORN Web App
            </span>
          </div>
          <h2 className="max-w-3xl text-5xl font-semibold leading-[1.02] tracking-[-0.06em] text-[#15130F] md:text-6xl">
            KHORN Web App แค่... ส่งเอกสารให้ KHORN อ่าน
          </h2>

          <div className="mt-9 space-y-5">
            {items.map((item) => (
              <div key={item} className="flex items-start gap-4 text-xl font-semibold leading-8 text-[#5F665E]">
                <span className="mt-1 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#78C46B] text-white">
                  ✓
                </span>
                <span>{item}</span>
              </div>
            ))}
          </div>

          <p className="mt-8 max-w-2xl text-xl leading-9 text-[#5F665E]">
            จากเดิมที่ต้องไล่อ่านเองทั้งหมด ทีมแค่ส่งข้อมูลเข้า KHORN แล้วรอผลลัพธ์ที่พร้อมตรวจต่อ
          </p>
        </article>
      </div>
    </section>
  );
}

function PlatformSection() {
  const [lineIndex, setLineIndex] = useState(0);
  const activeLineCase = lineUseCases[lineIndex];
  const platformExplanations = [
    ["01", "ถามกฎหมายพร้อมแหล่งอ้างอิง", "ผู้ใช้ถามจาก LINE แล้ว KHORN ตอบพร้อมลิงก์กฎหมายและฎีกาที่เกี่ยวข้อง เพื่อให้ทีมกดตรวจแหล่งอ้างอิงต่อได้ทันที"],
    ["02", "มอบหมายงานจากแชต", "พิมพ์งานที่ต้องการสร้าง กำหนดคนรับผิดชอบ กำหนดเวลา และผูกงานเข้ากับแฟ้มคดีโดยไม่ต้องเปิดแดชบอร์ด"],
    ["03", "ถามงานที่ยังไม่เสร็จ", "ระบบสรุปงานค้าง งานติดขัด และสิ่งที่ต้องตามต่อจากทุกแฟ้มคดีที่เกี่ยวข้องกับทีม"],
    ["04", "แจ้งเตือนงานใหม่", "เมื่อมีงานถูกมอบหมายหรือมีกำหนดเวลาสำคัญ ทีมจะได้รับการแจ้งเตือนใน LINE พร้อมปุ่มเปิดงาน"],
    ["05", "รายงานสรุปอัตโนมัติ", "ส่งภาพรวมงานเสร็จ งานค้าง เคสที่ต้องดูแล และสิ่งที่ต้องเร่งต่อเป็นรายงานสั้น ๆ"],
    ["06", "ตามงานลูกความ", "ให้ระบบส่งข้อความตามเอกสารหรือข้อมูลจากลูกความ และตั้งเตือนซ้ำหากยังไม่มีการตอบกลับ"],
  ];
  const activeExplanation = platformExplanations[lineIndex];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setLineIndex((current) => (current + 1) % lineUseCases.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <section id="line-product" className="mx-auto max-w-[1440px] px-4 py-20 md:px-6">
      <div className="p-0 md:px-4 lg:px-8">
        <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_390px]">
          <article className="pt-2">
            <div className="mb-5 inline-flex items-center gap-3 rounded-full bg-[#F2FBF4] px-4 py-2">
              <span className="grid h-8 w-8 place-items-center rounded-xl bg-[#06C755] text-[10px] font-black text-white">
                LINE
              </span>
              <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#18A64A]">
                KHORN LINE
              </span>
            </div>
          <h2 className="max-w-4xl text-4xl font-medium leading-[0.98] tracking-[-0.05em] md:text-5xl">
              KHORN LINE สำหรับถาม ร่าง และสั่งงานจากมือถือ
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-7 text-[#5F665E]">
              ผู้ช่วยใน LINE สำหรับงานประจำวันที่ไม่ต้องเปิดระบบใหญ่ ทั้งถามกฎหมาย สร้างงาน ร่างเอกสาร และเช็กข้อมูลลูกความ
          </p>

            <PlatformTypingCopy
              key={activeExplanation[0]}
              number={activeExplanation[0]}
              label={activeLineCase.label}
              title={activeExplanation[1]}
              text={activeExplanation[2]}
            />

            <div className="mt-5 flex max-w-3xl flex-wrap gap-2">
              {platformExplanations.map(([num, title], index) => (
                <button
                  key={num}
                  type="button"
                  onClick={() => setLineIndex(index)}
                  className={`rounded-full px-4 py-2 text-xs font-medium transition ${
                    index === lineIndex
                      ? "bg-[#15130F] text-white"
                      : "border border-[#E3E6DF] bg-white text-[#6A7168]"
                  }`}
                >
                  {num} {title}
                </button>
              ))}
            </div>
          </article>

          <article className="relative justify-self-center lg:-mt-1">
            <div className="absolute left-[-4px] top-24 h-20 w-1 rounded-l-full bg-[#0D0F0E]" />
            <div className="absolute right-[-4px] top-32 h-24 w-1 rounded-r-full bg-[#0D0F0E]" />
            <div className="mx-auto h-[620px] w-[330px] overflow-hidden rounded-[44px] bg-[#0D0F0E] p-[10px] shadow-[0_28px_70px_rgba(0,0,0,0.28)]">
              <div className="h-full overflow-hidden rounded-[34px] bg-white">
              <div className="flex h-full flex-col">
                <div className="bg-white px-4 pb-3 pt-4 text-[#15130F]">
                  <div className="mb-4 flex items-center justify-between text-xs font-semibold">
                    <span>14:45</span>
                    <span className="text-[10px]">●●● Wi-Fi 42%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-xl">‹</span>
                      <span className="text-base font-semibold">99+</span>
                      <div>
                        <p className="text-lg font-semibold leading-none">ค้อน เอไอ</p>
                        <p className="mt-1 text-xs text-[#747B72]">{activeLineCase.label}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 text-xl">
                      <span>⌕</span>
                      <span>☏</span>
                      <span>☰</span>
                    </div>
                  </div>
                </div>

                <div className="relative flex-1 overflow-hidden bg-[#8EADD5] px-3 py-4">
                    <div key={activeLineCase.label} className="space-y-4 transition-all duration-500">
                      <div className="line-bubble-in ml-auto max-w-[80%] rounded-[20px] rounded-tr-md bg-[#61E86D] px-4 py-3 text-[14px] leading-6 text-[#15130F] shadow-sm">
                      {activeLineCase.user}
                    </div>

                    <div className="line-bubble-in flex items-start gap-2" style={{ animationDelay: "520ms" }}>
                      <LogoAvatar />
                      <div className="max-w-[83%]">
                        <p className="mb-1 text-xs font-semibold text-[#4E6684]">ค้อน เอไอ</p>
                        <div className="rounded-[20px] rounded-tl-md bg-white px-4 py-3 text-[14px] leading-6 text-[#15130F] shadow-sm">
                          {activeLineCase.ai}
                          {activeLineCase.refs.length > 0 && (
                            <div className="mt-3 space-y-1">
                              {activeLineCase.refs.map((ref) => (
                                <a
                                  key={ref}
                                  href="/mcp"
                                  className="block text-[#2F65C8] underline underline-offset-2"
                                >
                                  {ref}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="line-bubble-in flex items-start gap-2" style={{ animationDelay: "1120ms" }}>
                      <LogoAvatar />
                      <div className="max-w-[86%] overflow-hidden rounded-[22px] bg-white shadow-sm">
                        <div className="bg-[#0D0F0E] px-4 py-4 text-white">
                          <p className="text-xs font-semibold tracking-[0.12em] text-[#A7E6B0]">
                            KHORN
                          </p>
                          <h3 className="mt-2 text-2xl font-semibold leading-tight">
                            {activeLineCase.cardTitle}
                          </h3>
                          <p className="mt-1 text-base text-[#BDEFC5]">
                            {activeLineCase.cardSubtitle}
                          </p>
                        </div>
                        <div className="space-y-2 px-4 py-4 text-[14px] leading-6 text-[#343834]">
                          {activeLineCase.cardLines.map((line, index) => (
                            <p key={line}>
                              {index + 1}. {line}
                            </p>
                          ))}
                          <a
                            href="https://app.khorn-ai.com/plan"
                            className="mt-4 block rounded-xl bg-[#18A64A] px-4 py-3 text-center text-sm font-medium text-white"
                          >
                            {activeLineCase.button}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="absolute bottom-4 right-4 grid h-10 w-10 place-items-center rounded-xl bg-white text-xl shadow-lg">
                    ↓
                  </div>
                </div>

                <div className="flex items-center gap-2 bg-white px-3 py-3 text-[#15130F]">
                  <span className="text-2xl">＋</span>
                  <span className="text-xl">▣</span>
                  <div className="flex-1 rounded-full bg-[#F4F4F4] px-4 py-2 text-[#B5B5B5]">
                    Aa
                  </div>
                  <span className="text-xl">◉</span>
                </div>
              </div>
            </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

function PlatformTypingCopy({ number, label, title, text }) {
  const [titleIndex, setTitleIndex] = useState(0);
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    setTitleIndex(0);
    setTextIndex(0);
  }, [number, title, text]);

  useEffect(() => {
    if (titleIndex < title.length) {
      const timeout = window.setTimeout(() => {
        setTitleIndex((value) => value + 1);
      }, 34);

      return () => window.clearTimeout(timeout);
    }

    if (textIndex < text.length) {
      const timeout = window.setTimeout(() => {
        setTextIndex((value) => value + 1);
      }, 13);

      return () => window.clearTimeout(timeout);
    }
  }, [text, textIndex, title, titleIndex]);

  const typedTitle = title.slice(0, titleIndex);
  const typedText = text.slice(0, textIndex);
  const isTypingTitle = titleIndex < title.length;
  const isTypingText = !isTypingTitle && textIndex < text.length;

  return (
    <div className="mt-8 max-w-3xl">
      <div className="mb-5 flex items-center gap-3">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#15130F] text-sm font-medium text-white">
          {number}
        </span>
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#6A7168]">
            กำลังแสดง: {label}
          </p>
          <div className="mt-2 flex gap-1.5">
            {[0, 1, 2].map((item) => (
              <span
                key={item}
                className={`h-1.5 rounded-full transition-all ${
                  item === 0 ? "w-8 bg-[#15130F]" : "w-3 bg-[#D8E1D2]"
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="min-h-[210px]">
        <h3 className="max-w-3xl text-5xl font-medium leading-[0.95] tracking-[-0.06em] text-[#15130F] md:text-6xl">
          {typedTitle || "\u00A0"}
          {isTypingTitle && (
            <span className="ml-2 inline-block h-[0.78em] w-[0.07em] translate-y-[0.08em] animate-pulse bg-[#15130F]" />
          )}
        </h3>

        <p className="mt-6 max-w-2xl text-xl leading-9 tracking-[-0.02em] text-[#5F665E]">
          {typedText || "\u00A0"}
          {isTypingText && (
            <span className="ml-1 inline-block h-[0.9em] w-[0.08em] translate-y-[0.12em] animate-pulse bg-[#15130F]" />
          )}
        </p>
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        {["คำสั่งใน LINE", "KHORN ลงมือทำ", "ทีมเห็นงานต่อ"].map((item) => (
          <span
            key={item}
            className="rounded-full border border-[#E3E6DF] bg-white px-4 py-2 text-xs font-medium text-[#6A7168]"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}

function SecuritySection() {
  const controls = [
    ["รองรับงานข้อมูลส่วนบุคคล", "เหมาะกับเอกสารและข้อมูลลูกความที่ละเอียดอ่อน"],
    ["ไม่ใช้ข้อมูลไปฝึกโมเดลสาธารณะ", "ไม่ใช้ข้อมูลสำนักงานไปฝึกโมเดลสาธารณะ"],
    ["ควบคุมสิทธิ์ตามบทบาท", "ควบคุมสิทธิ์ตามทีม บทบาท และเคส"],
    ["ประวัติการทำงาน", "ตรวจสอบการแก้ไข มอบหมาย และอนุมัติย้อนหลังได้"],
  ];

  return (
    <section id="security" className="mx-auto max-w-[1440px] px-4 py-10 md:px-6">
      <div className="grid overflow-hidden rounded-[28px] bg-[#15130F] lg:grid-cols-[0.9fr_1.1fr]">
        <div className="p-8 md:p-12">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#8FA083]">
            ความปลอดภัยและการควบคุม
          </p>
          <h2 className="mt-5 text-5xl font-medium leading-[0.95] tracking-[-0.06em] text-[#FAFAF7] md:text-7xl">
            ออกแบบเพื่อข้อมูลลูกความและเอกสารคดี
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-8 text-[#7C8579]">
            ควบคุมสิทธิ์ เก็บประวัติการทำงาน และยึดแนวทางไม่ใช้ข้อมูลผู้ใช้ไปฝึกโมเดลสาธารณะ
          </p>
        </div>

        <div className="grid bg-white/[0.03] lg:grid-cols-2">
          {controls.map(([title, desc]) => (
            <div
              key={title}
              className="p-6"
            >
              <p className="text-lg font-medium text-[#FAFAF7]">{title}</p>
              <p className="mt-3 text-sm leading-6 text-[#747B72]">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function PricingSection() {
  return (
    <section id="pricing" className="mx-auto max-w-[1440px] px-4 py-20 md:px-6">
      <div className="p-0 md:px-4 lg:px-8">
        <SectionHeader
          eyebrow="ราคา"
          title="แพ็กเกจสำหรับนักกฎหมายและสำนักงาน"
              text="เริ่มจากนักกฎหมายรายบุคคล ไปจนถึงทีมกฎหมายที่ต้องการขั้นตอนทำงานและระบบควบคุมระดับสำนักงาน"
        />

        <div className="grid gap-5 lg:grid-cols-3">
          {pricing.map((plan) => (
            <article
              key={plan.name}
              className={`rounded-[30px] border p-8 ${
                plan.featured
                  ? "border-[#15130F] bg-white shadow-[0_18px_60px_rgba(48,38,24,0.10)]"
                  : "border-[#E3E6DF] bg-white"
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="text-sm font-medium uppercase tracking-[0.2em]">
                  {plan.name}
                </div>
                {plan.featured && (
                  <span className="rounded-full bg-[#EEF3EA] px-3 py-1 text-xs font-medium text-[#3F4D3D]">
                    แนะนำ
                  </span>
                )}
              </div>

              <div className="mt-8 flex items-end gap-2">
                {plan.price === "ปรับได้" ? (
                  <div className="text-5xl font-medium tracking-[-0.06em]">
                    {plan.price}
                  </div>
                ) : (
                  <>
                    <div className="text-6xl font-medium tracking-[-0.08em]">
                      ฿{plan.price}
                    </div>
                    <div className="pb-2 text-sm text-[#6A7168]">/ เดือน</div>
                  </>
                )}
              </div>

              <p className="mt-6 min-h-[72px] text-sm leading-7 text-[#5F665E]">
                {plan.desc}
              </p>

              <div className="mt-8 space-y-3">
                {plan.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-3 text-sm font-medium">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-[#15130F] text-[10px] text-[#FAFAF7]">
                      ✓
                    </span>
                    {feature}
                  </div>
                ))}
              </div>

              <a
                href={plan.href}
                className="mt-10 inline-flex h-14 w-full items-center justify-center rounded-full bg-[#15130F] px-6 py-4 text-sm font-medium text-[#FAFAF7] transition hover:bg-[#1F2A22]"
              >
                    {plan.name === "Custom" ? "คุยแพ็กเกจเฉพาะ" : "เลือกแพ็กเกจนี้"}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  const midpoint = Math.ceil(testimonials.length / 2);
  const topQuotes = testimonials.slice(0, midpoint);
  const bottomQuotes = testimonials.slice(midpoint);
  const topMarqueeQuotes = [...topQuotes, ...topQuotes];
  const bottomMarqueeQuotes = [...bottomQuotes, ...bottomQuotes];

  return (
    <section className="overflow-hidden bg-white py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="mb-10 flex items-end justify-between gap-6 md:px-4 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.2em] text-[#6A7168]">
              เสียงจากผู้ใช้
            </p>
            <h2 className="mt-4 text-4xl font-medium tracking-[-0.05em] md:text-6xl">
              งานลูกความชัดขึ้น ตั้งแต่วันแรก
            </h2>
            <p className="mt-5 text-lg leading-8 text-[#6A7168]">
              เสียงจากทีมที่อยากลดเวลาตามข้อมูล ตามเอกสาร และตามงานค้าง
            </p>
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-white to-transparent md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-white to-transparent md:w-40" />

        <div className="testimonial-marquee flex gap-4">
          {topMarqueeQuotes.map((quote, index) => (
            <TestimonialCard key={`${quote}-${index}`} quote={quote} index={index} />
          ))}
        </div>

        <div className="testimonial-marquee-reverse mt-4 flex gap-4">
          {bottomMarqueeQuotes.map((quote, index) => (
            <TestimonialCard key={`bottom-${quote}-${index}`} quote={quote} index={index + midpoint} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ quote, index }) {
  const names = [
    "ทีมคดีแพ่ง",
    "สำนักงานกฎหมาย SME",
    "ทีมสัญญา",
    "ผู้ช่วยทนาย",
    "หัวหน้าทีมกฎหมาย",
    "ทีมดำเนินคดี",
    "ทีมเอกสาร",
    "ทีมที่ปรึกษา",
    "สำนักงานคดีธุรกิจ",
    "ทีมจัดการเคส",
  ];
  const icons = ["●", "◆", "✦", "◐", "⬟", "✺", "✹", "●", "◆", "✦"];
  const colors = ["#78C46B", "#F5A11A", "#3777E3", "#FF7A59", "#9B7CF6", "#18A64A", "#7FB8D8", "#D6A85C", "#6BBF9A", "#E06C9F"];

  return (
    <article className="w-[330px] shrink-0 rounded-[28px] bg-[#FAFAF7] p-7 shadow-[0_18px_50px_rgba(22,29,24,0.08)] md:w-[390px]">
      <p className="min-h-[120px] text-xl font-medium leading-9 tracking-[-0.03em] text-[#242622]">
        “{quote}”
      </p>
      <div className="mt-10 flex items-center gap-3">
        <span
          className="grid h-9 w-9 place-items-center rounded-full text-sm text-white"
          style={{ backgroundColor: colors[(index + 2) % colors.length] }}
        >
          {icons[(index + 2) % icons.length]}
        </span>
        <div>
          <p className="text-sm font-semibold text-[#15130F]">
            {names[index % names.length]}
          </p>
          <p className="text-xs text-[#7C8579]">ผู้ใช้งาน KHORN AI</p>
        </div>
      </div>
    </article>
  );
}

function FAQSection() {
  return (
    <section className="mx-auto max-w-[1440px] px-4 py-20 md:px-6">
      <div className="p-0 md:px-4 lg:px-8">
        <SectionHeader eyebrow="FAQ" title="คำถามที่พบบ่อย" />

        <div className="space-y-4">
          {faqs.map((item) => (
            <article
              key={item.q}
              className="rounded-[24px] border border-[#E3E6DF] bg-white p-6"
            >
              <h3 className="text-xl font-medium">{item.q}</h3>
              <p className="mt-3 leading-7 text-[#5F665E]">{item.a}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer id="company" className="mx-auto max-w-[1440px] px-4 pb-8 pt-4 md:px-6">
      <div className="flex flex-col justify-between gap-5 border-t border-[#E3E6DF] pt-6 text-sm text-[#6A7168] md:flex-row md:items-center">
        <div>
          <p className="font-medium text-[#15130F]">KHORN AI © 2026</p>
          <p className="mt-1">AI สำหรับทีมกฎหมาย</p>
        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-3 font-medium">
          <a href="/privacy-policy" className="transition hover:text-[#15130F]">
            นโยบายความเป็นส่วนตัว
          </a>
          <a href="/business-policy" className="transition hover:text-[#15130F]">
            ข้อกำหนดการใช้บริการ
          </a>
          <a href="/contact" className="transition hover:text-[#15130F]">
            ติดต่อ
          </a>
        </nav>
      </div>
    </footer>
  );
}

function SectionHeader({ eyebrow, title, text }) {
  return (
    <div className="mb-14 max-w-4xl">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#6A7168]">
        {eyebrow}
      </p>
      <h2 className="mt-5 text-5xl font-medium leading-[0.95] tracking-[-0.06em] md:text-7xl">
        {title}
      </h2>
      {text && (
        <p className="mt-6 max-w-2xl text-lg leading-8 text-[#5F665E]">
          {text}
        </p>
      )}
    </div>
  );
}
